import { MouseEvent } from 'react';
import styled from 'styled-components';

import CoreSvg from '../CoreSvg';

// 컬러타입
import { tagColorType } from '../../utils/colorType';
import { DeleteIconWrapper } from '../chips/style';
import Icon from 'shared/icons';

type TagType = 'close' | 'text' | 'num';
export type ColorType =
	| 'primary'
	| 'secondary'
	| 'black'
	| 'gray'
	| 'red'
	| 'yellow'
	| 'green'
	| 'blue';

export interface ITag {
	tag_type: TagType;
	color_type: ColorType;
	value?: string;
	num?: number;
	deleteChips?: (chips_value: string | undefined) => void;
	_onClick?: (() => void) | ((e: MouseEvent<HTMLDivElement>) => void);
	_onMouseEnter?: () => void;
	_onMouseLeave?: () => void;
	_margin?: string;
}

const CoreTag = ({
	tag_type,
	color_type,
	value,
	num,
	deleteChips = () => undefined,
	_onClick,
	_onMouseEnter,
	_onMouseLeave,
	_margin,
}: ITag) => {
	if (tag_type === 'text')
		return (
			<TextTag
				color_type={color_type}
				onClick={_onClick}
				is_clickable={_onClick ? true : false}
				_margin={_margin}
			>
				{value}
			</TextTag>
		);
	if (tag_type === 'close')
		return (
			<CloseTextTag
				color_type={color_type}
				onClick={_onClick}
				is_clickable={_onClick ? true : false}
				_margin={_margin}
			>
				{value}
				<DeleteIconWrapper
					onClick={() => {
						deleteChips(value);
					}}
				>
					<CoreSvg>
						<Icon.Close />
					</CoreSvg>
				</DeleteIconWrapper>
			</CloseTextTag>
		);
	if (tag_type === 'num' && num)
		return (
			<NumTag
				color_type={color_type}
				onClick={_onClick}
				onMouseEnter={_onMouseEnter}
				onMouseLeave={_onMouseLeave}
				is_clickable={_onClick ? true : false}
				_margin={_margin}
			>
				{/* {num <= 999 ? num : `999+`} */}
				{num}
			</NumTag>
		);
	return null;
};

const TextTag = styled.div<{
	color_type: ColorType | string;
	is_clickable: boolean;
	_margin?: string;
}>`
	width: max-content;
	white-space: nowrap;
	height: 24px;
	padding: 0 8px;
	border-radius: 12px;

	${({ theme }) => theme.typo.body.span_bold};

	${({ theme }) => theme.common.flexCenter};

	${({ color_type }) => color_type === 'primary' && tagColorType.primary};
	${({ color_type }) => color_type === 'secondary' && tagColorType.secondary};
	${({ color_type }) => color_type === 'black' && tagColorType.black};
	${({ color_type }) => color_type === 'gray' && tagColorType.gray};
	${({ color_type }) => color_type === 'red' && tagColorType.red};
	${({ color_type }) => color_type === 'yellow' && tagColorType.yellow};
	${({ color_type }) => color_type === 'green' && tagColorType.green};
	${({ color_type }) => color_type === 'blue' && tagColorType.blue};

	cursor: ${({ is_clickable }) => (is_clickable ? `pointer` : `inherit`)};

	${({ _margin }) => _margin && `margin: ${_margin}`};
	flex-shrink: 0;
`;

const CloseTextTag = styled(TextTag)`
	height: 32px;
	padding: 0 8px 0 12px;
	border-radius: 16px;

	& > span {
		margin-left: 4px;
		cursor: pointer;
		width: 18px;
		height: 18px;
	}
`;

const NumTag = styled(TextTag)`
	min-width: 24px;
	height: 24px;
	border-radius: 12px;
`;

export default CoreTag;
